import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=3339c6bd&scoped=true"
import script from "./Orcamentos.vue?vue&type=script&lang=js"
export * from "./Orcamentos.vue?vue&type=script&lang=js"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=3339c6bd&prod&scoped=true&lang=css"
import style1 from "./Orcamentos.vue?vue&type=style&index=1&id=3339c6bd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3339c6bd",
  null
  
)

export default component.exports